import { render, staticRenderFns } from "./OpendataWellcome.vue?vue&type=template&id=c2a8b3b6&"
import script from "./OpendataWellcome.vue?vue&type=script&lang=js&"
export * from "./OpendataWellcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports